import { useState } from 'react';
import { URL_REGEX } from '../constants';

export const useMessageHandlers = (
  messageContent: string,
  setMessageContent: (content: string) => void
) => {
  const [showLinkDialog, setShowLinkDialog] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const [linkName, setLinkName] = useState('');

  const handleMessageContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let value = e.target.value;
    
    // URL検出とリンク化
    if (URL_REGEX.test(value) && !showLinkDialog) {
      const match = value.match(URL_REGEX);
      if (match) {
        setCurrentUrl(match[0]);
        setShowLinkDialog(true);
      }
    }
    
    setMessageContent(value);
  };

  const handleLinkNameSave = () => {
    if (linkName.trim()) {
      // URLをリンク名で置換
      const newContent = messageContent.replace(currentUrl, linkName);
      setMessageContent(newContent);
    }
    
    setShowLinkDialog(false);
    setCurrentUrl('');
    setLinkName('');
  };

  const handleLinkDialogCancel = () => {
    setShowLinkDialog(false);
    setCurrentUrl('');
    setLinkName('');
  };

  return {
    showLinkDialog,
    currentUrl,
    linkName,
    setLinkName,
    handleMessageContentChange,
    handleLinkNameSave,
    handleLinkDialogCancel
  };
}; 